import styled, {keyframes} from "styled-components";
import Logo from "../../../assets/images/Logo-Small-Timed-Light.png"

interface TimedLoadingVLightCtrlProps {
    className?:string;
    width?:string;
}

const TimedLoadingVLightCtrl = (props: TimedLoadingVLightCtrlProps) => {
    return (
        <div className={`timed_loading ${props.className}`}>
            <div className={"voile"}/>
            <div className="rotateWait"></div>
            <img src={Logo} alt="Logo" />
        </div>
    )
}

const AnimationRotate = keyframes`
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
`

export const TimedLoadingVLight = styled(TimedLoadingVLightCtrl)`
    position: relative;
    width: ${props => props.width ? props.width : "120px"};
    text-align: center;
    position: relative;
    .voile{
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(255,255,255,0.5);
        z-index: 2;
        width: 100%;
        height: 100%;
    }
    img{
        width: 90%;
        height: auto;
        margin: auto;
    }
    .rotateWait{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border-width: 3px;
        border-style: solid;
        border-color: white ${props=>props.theme.PrimaryLight} white;
        animation:${AnimationRotate} 2s infinite;
    }
`